import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'
import RequesterData from '@/types/RequesterData'
import ProjectData from '@/types/ProjectData'
import RoomData from '@/types/RoomData'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    requester: new RequesterData(),
    projectData: new ProjectData(),
    roomsData: [] as RoomData[],
    quote: {} as object,
    formValidity: {
      requesterForm: false,
      projectForm: false,
      roomsForm: false
    }
  },
  getters: {
    getField,
    getAllDataAsJson (state) {
      let csrfToken = (state.quote as any)?.token //eslint-disable-line
      if (csrfToken) {
        const csrfName = Object.keys(csrfToken)[0]
        const csrfVal = csrfToken[csrfName]
        csrfToken = ',"' + csrfName + '": "' + csrfVal + '"'
      } else {
        csrfToken = ''
      }

      return '{' +
      '"requesterData":' + JSON.stringify(state.requester, state.requester.replacer) + ',' +
      '"projectData":' + JSON.stringify(state.projectData, state.projectData.replacer) + ',' +
      '"roomsData":' + JSON.stringify(state.roomsData, state.roomsData[0]?.replacer) + //eslint-disable-line
      csrfToken +
      '}'
    }
  },
  mutations: {
    addRoom: (state, roomData: RoomData) => { state.roomsData.push(roomData) },
    removeRoom: (state, index: number) => { state.roomsData.splice(index, 1) },
    setRoomProperty: (state, data: any) => { //eslint-disable-line
      state.roomsData.forEach((room: RoomData) => {
        (room as any)[data.type] = (data.selected.find((selectedRoom: RoomData) => selectedRoom.name === room.name) !== undefined) //eslint-disable-line
      })
    },
    setQuote: (state, quoteData) => { state.quote = quoteData },
    resetAll: (state) => {
      state.requester = new RequesterData()
      state.projectData = new ProjectData()
      state.roomsData = []
      state.quote = {}
      state.formValidity.requesterForm = false
      state.formValidity.projectForm = false
      state.formValidity.roomsForm = false
    },
    updateField
  },
  actions: {
  }
})
